import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const COOKIE_CONSENT_KEY = 'fopmn_cookie_consent';

export default function CookieBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setVisible(true);
  }, []);

  const acceptAll = () => {
    try {
      localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({ essential: true, analytics: true, timestamp: Date.now() }));
    } catch { /* ignore */ }
    setVisible(false);
  };

  const acceptEssential = () => {
    try {
      localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({ essential: true, analytics: false, timestamp: Date.now() }));
    } catch { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] bg-stone-900/50 text-white shadow-2xl backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6">
        <div className="flex-1">
          <p className="text-[11px] md:text-sm font-inter leading-relaxed text-stone-200">
            {t('cookie.text')}
          </p>
          <div className="flex items-center gap-4 mt-2">
            <Link to="/politica-cookie" className="text-amber-400 hover:text-amber-300 text-[10px] md:text-xs font-inter transition-colors underline">
              {t('footer.link_cookies')}
            </Link>
            <Link to="/politica-confidentialitate" className="text-amber-400 hover:text-amber-300 text-[10px] md:text-xs font-inter transition-colors underline">
              {t('footer.link_privacy')}
            </Link>
          </div>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={acceptEssential}
            className="px-4 py-1.5 text-[12px] md:px-6 md:py-2.5 md:text-sm bg-amber-500 hover:bg-amber-400 text-stone-800 font-semibold font-inter rounded-md transition-all cursor-pointer whitespace-nowrap"
          >
            {t('cookie.essential')}
          </button>
          <button
            onClick={acceptAll}
            className="px-4 py-1.5 text-[12px] md:px-6 md:py-2.5 md:text-sm bg-amber-500 hover:bg-amber-400 text-stone-800 font-semibold font-inter rounded-md transition-all cursor-pointer whitespace-nowrap"
          >
            {t('cookie.accept_all')}
          </button>
        </div>
      </div>
    </div>
  );
}